import angular from 'angular';
import pipelineLabelForm from './pipelineLabelForm';
import './style.scss';

export default angular
  .module('components.pipelineLabelForm', [])
  .component('pipelineLabelForm', pipelineLabelForm).name;
